/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const liveSearchProductsButtons = {
    /**
     * Show previous load button
     *
     * @returns {boolean}
     */
    showPreviousLoadButton() {
        return !this.productsLoading
            && this.products.length > 0
            && !this.pagesLoaded.includes(1);
    },
    /**
     * Callback for previous load button
     */
    callbackPreviousLoadButton() {
        const lowestPage = Math.min(...this.pagesLoaded);
        this.getProducts('previous', lowestPage - 1);
    },
    /**
     * Show next load button
     *
     * @returns {boolean}
     */
    showNextLoadButton() {
        return !this.productsLoading
            && this.products.length > 0
            && !this.pagesLoaded.includes(this.pagesTotal);
    },
    /**
     * Callback for next load button
     */
    callbackNextLoadButton() {
        const highestPage = Math.max(...this.pagesLoaded);
        this.getProducts('next', highestPage + 1);
    }
}

export default liveSearchProductsButtons;
